import { render, staticRenderFns } from "./invoices-show.vue?vue&type=template&id=2a4382d9&scoped=true&"
import script from "./invoices-show.vue?vue&type=script&lang=ts&"
export * from "./invoices-show.vue?vue&type=script&lang=ts&"
import style0 from "./invoices-show.vue?vue&type=style&index=0&id=2a4382d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4382d9",
  null
  
)

export default component.exports